import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import { GHOST_POSTS_GET_URL } from "../../../constant/index";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const Blogs = () => {
    const [ posts, setPosts ] = useState([]);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const { data } = await axios.get(GHOST_POSTS_GET_URL);
                setPosts(data?.posts);
            } catch (error) {
                console.error("Error fetching posts:", error);
            }
        };

        fetchPosts();
    }, []);

    const sliderSettings = {
        dots: true,
        infinite: posts.length > 1,   // only loop if multiple posts
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
    };

    return (
        <div className="container">
            <div className="hr"></div>
            <div className="row mb-2">
                <div className="col-12">
                    <h1 className="page-title-master">Blog</h1>
                    <p>Welcome to our blog! Here, we share insights, tips, and strategies to help you navigate the world of trading and investing. Stay tuned for regular updates!!</p>
                </div>
                
            </div>
            <Slider {...sliderSettings}>
                    {
                        posts.map(({ uuid, html, title }) => (
                            <div key={uuid} className="p-3">
                                <div className="blog-card shadow-sm border rounded p-3">
                                    <h3 className="text-lg font-bold mb-2">{title}</h3>
                                    <div dangerouslySetInnerHTML={{ __html: html }} />
                                </div>
                            </div>
                        ))
                    }
                </Slider>
        </div>
        
    );
}

export default Blogs;